import { useQuery } from '@apollo/client';
import { GET_CURRENT_USER_PAYMENTS } from '../api';
import {
  CurrentUserPaymentsVariables,
  GetCurrentUserPaymentsQuery,
} from '../api/types';

interface UseUserPaymentsOptions {
  variables: CurrentUserPaymentsVariables;
  skip?: boolean;
}

export const useUserPayments = ({
  variables,
  skip = false,
}: UseUserPaymentsOptions) => {
  const { data, loading, fetchMore, refetch } =
    useQuery<GetCurrentUserPaymentsQuery>(GET_CURRENT_USER_PAYMENTS, {
      skip,
      fetchPolicy: 'cache-and-network',
      variables: {
        first: variables.first,
        after: variables.after ?? null,
      },
    });

  return {
    loading,
    refetch,
    fetchMore,
    payments: data?.currentUserPayments?.nodes ?? [],
    totalCount: data?.currentUserPayments?.totalCount ?? 0,
    endCursor: data?.currentUserPayments?.pageInfo?.endCursor,
    hasNextPage: data?.currentUserPayments?.pageInfo?.hasNextPage ?? false,
  };
};
